import { Datepicker } from 'vanillajs-datepicker';
import nl from 'vanillajs-datepicker/locales/nl';

Object.assign(Datepicker.locales, nl);

export default class FillForm {
    constructor() {
        this.formShortened = document.querySelectorAll('.fill-form');

        this.newDateField = document.getElementById('input_1_1');
        this.newStartTimeField = document.getElementById('input_1_11');
        this.newEndTimeField = document.getElementById('input_1_12');

        this.formShortened.forEach(form => {
            form.addEventListener('submit', this.handleSubmit.bind(this));
            let datepicker = form.querySelector('[data-datepicker]');
            if (datepicker) {
                new Datepicker(datepicker, {
                    language: 'nl',
                    minDate: new Date(),
                });
            }
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        let dateField = e.target.querySelector('.field-datepicker-fill');
        let startTimeField = e.target.querySelector('.field-start-time');
        let endTimeField = e.target.querySelector('.field-end-time');

        this.newDateField.value = dateField.value;
        this.newStartTimeField.value = startTimeField.value;
        this.newEndTimeField.value = endTimeField.value;
    }
}